exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".note .note-title{text-transform:uppercase}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/Note/styles.scss
// module id = 1485
// module chunks = 0